import { render, staticRenderFns } from "./RegistrationDocumentTypeSelectbox.vue?vue&type=template&id=716e1377&"
import script from "./RegistrationDocumentTypeSelectbox.vue?vue&type=script&lang=js&"
export * from "./RegistrationDocumentTypeSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports